import React from "react";
import {LazyLoadImage, LazyLoadImageProps} from "react-lazy-load-image-component";

import {isCI} from "../../utils/env";

export const LazyImg: React.FC<LazyLoadImageProps> = ({visibleByDefault, ...props}) => (
  <LazyLoadImage {...props} visibleByDefault={!!isCI || visibleByDefault} />
);
